import React from "react";

import { Provider } from "react-redux";

import * as Sentry from "@sentry/react";
import { PrimeReactProvider } from "primereact/api";
import ReactDOM from "react-dom/client";
import { PersistGate } from "redux-persist/integration/react";

import { APP_ENV, SENTRY_DNS } from "@/modules/auth/constants";

import App from "./App";
import { persistor, store } from "./store";

// Initialize Sentry only if DSN is provided and in production
if (SENTRY_DNS && APP_ENV == "production") {
  Sentry.init({
    dsn: SENTRY_DNS,
    environment: APP_ENV || "development",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: APP_ENV === "production" ? 0.1 : 1.0,
    replaysOnErrorSampleRate: 0.1,
    sendDefaultPii: true,
    beforeSend(event, _hint) {
      if (APP_ENV === "development") {
        console.log("Sentry event (development):", event);
        return null;
      }
      return event;
    },
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PrimeReactProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </PrimeReactProvider>
  </React.StrictMode>
);
